import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportMoBranches } from '@api/configurationComparison';

import { IMutateExportMoBranchesDTO } from '@interfaces/cmModule/dto/configurationComparisonDTO';
import { ITreeInitial } from '@interfaces/components/tree';

import { EMenuActionsTypes, ESnackbarTypes } from '@enums/common';

import { MO_BRANCHES_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateExportMoBranches = (tree?: {
	moTree: ITreeInitial;
	treeIds: string;
}) => {
	const dispatch = useAppDispatch();

	const { mutate: exportBranches } = useMutation<IMutateExportMoBranchesDTO>({
		mutationKey: [MO_BRANCHES_EXPORT],
		mutationFn: ({ branchIds, actionId, presetDumpId }: IMutateExportMoBranchesDTO) => {
			exportMoBranches({
				dumpId: tree?.treeIds || presetDumpId,
				ids: actionId === EMenuActionsTypes.all ? null : branchIds,
			});
		},
		enabled: [!!tree?.treeIds],
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportConfigurationComparisonSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return { exportBranches };
};
